import React from 'react';
// import logo from './logo.svg';
import './App.css';
import Home from './pages/Home';
import Confirmation from './pages/Confirmation'
//import Error from './pages/Error';
import ValidaVoto from './pages/ValidaVoto';
import { BrowserRouter, Switch, Route } from 'react-router-dom';


function App() {

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route path="/confirmacion" 
          render={(props) => <Confirmation {...props} isRegistered={true} />}/>
        <Route path="/subcuenta" 
          render={(props) => <Confirmation {...props} isSubcuenta={true} />}/>
        <Route path="/voted" 
          render={(props) => <Confirmation {...props} hasVoted={true} />}/>
        <Route path="/confirmaVotoRovirosa" component={ValidaVoto}/>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
